import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import jssVariables from "../../jss_setup";
import { StyleTypeContext } from "../../umbilical_tools";
import { CurrencyExcHoc } from "../../umbilical_hocs";

// TODO: Price Unify
var Price = ({ price, currency }) => {
  return price.toLocaleString("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  });
};
Price.propTypes = {
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
};
Price = CurrencyExcHoc(Price);

const styles = createUseStyles({
  OfferDiscountTag: (props) => ({
    position: "absolute",
    top: "-2.2rem",
    left: ".8rem",
    zIndex: 1,
    width: "max-content",
    ...(props?.customStyles?.OfferDiscountTag ?? {}),
  }),
  offerDiscountIcon: (props) => ({
    height: "8rem",
    width: "8rem",
    display: "block",
    ...(props?.customStyles?.offerDiscountIcon ?? {}),
  }),
  data: (props) => ({
    position: "absolute",
    display: "grid",
    gridTemplateRows: "max-content max-content",
    top: "50%",
    left: "50%",
    justifyItems: "center",
    paddingLeft: `calc(${jssVariables.normal_gap} * .8)`,
    paddingTop: `calc(${jssVariables.normal_gap} * 1.2)`,
    color: "white",
    transform: "translate(-50%, -75%)",
    ...(props?.customStyles?.data ?? {}),
  }),
  offerDiscContr: (props) => ({
    display: "grid",
    gridTemplateRows: "max-content max-content",
    gridTemplateColumns: "minmax(3.5rem, max-content)",
    borderRadius: "50%",
    justifyItems: "center",
    color: "white",
    alignContent: "center",
    aspectRatio: "1/1",
    transform: "translate(0%, 60%)",
    background: jssVariables.colors.base_color,
    padding: jssVariables.normal_gap,
    paddingTop: `calc(${jssVariables.normal_gap} / 3)`,
    ...(props?.customStyles?.offerDiscContr ?? {}),
  }),
  label: (props) => ({
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "small",
    lineHeight: "normal",
    ...(props?.customStyles?.label ?? {}),
  }),
  amount: (props) => ({
    fontSize: "x-large",
    ...(props?.customStyles?.amount ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    OfferDiscountTag: (props) => ({
      ...(props?.customStyles?.OfferDiscountTag?.smallscreen ?? {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    OfferDiscountTag: (props) => ({
      ...(props?.customStyles?.OfferDiscountTag?.bigscreen ?? {}),
    }),
    offerDiscountIcon: (props) => ({
      ...(props?.customStyles?.offerDiscountIcon?.bigscreen ?? {}),
    }),
    data: (props) => ({
      ...(props?.customStyles?.data?.bigscreen ?? {}),
    }),
    label: (props) => ({
      ...(props?.customStyles?.label?.bigscreen ?? {}),
    }),
  },
});
export const OfferDiscountTag = ({ offer }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = styles({
    customStyles: cStyler({ type, brand, objName: "offerDiscountTag" }),
  });

  return (
    <div className={classes.OfferDiscountTag}>
      <span className={classes.offerDiscContr}>
        <span className={classes.label}>{offer.label}</span>
        <span className={classes.amount}>
          {offer.type === "NUM" ? (
            <Price price={Math.ceil(offer.amount)} currency={offer.currency} />
          ) : (
            `${offer.amount.toFixed()}%`
          )}
        </span>
      </span>
    </div>
  );
};
OfferDiscountTag.propTypes = {
  offer: PropTypes.object.isRequired,
};
